<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable"  @checkbox="checkbox" @btnclick="bthClick" :pageData="pageData"></table-page>
    <UPDATE  ref="childUpdate"  @submit="submit" :updateData="updateData"></UPDATE>
  </div>
</template>

<script>
  //table封装组件
  import tablePage from '@/components/page/table.vue'
  import FORM from '@/components/page/form.vue'
  import URL from '@/views/cms/util/url'
  import UPDATE from '@/components/page/update.vue'
  import Qs from 'qs'
  import axios from 'axios'
  let newsTypeList = [], newsTypeArr = {}
  export default {
    name: 'list',
    components: {
      tablePage,
      FORM,
      UPDATE
    },
    created(){
      this.initCascader();
    },

    methods: {
      delNodes(nodes = []) {
        for (let item of nodes) {
          if (item.children.length <= 0) {
            delete item.children
          } else {
            this.delNodes(item.children)
          }
        }
        return nodes
      },
      addNodes(data) {
        for (let i in data) {
          newsTypeArr[data[i].value] = data[i].label
          if (data[i].children && data[i].children.length > 0) {
            this.addNodes(data[i].children)
          }
        }
        return newsTypeArr
      },
      initCascader() {
        this.$axios.post(URL.type.cascader, {}).then(res => {
          if (res.code == 0) {
            let data = JSON.parse(JSON.stringify(res.result))
            this.delNodes(data)
            this.updateData.cols.find(function(e) {
              return e.field == 'pids'
            }).optionList = data
            newsTypeList = data
            this.addNodes(data)
            this.$refs.childTable.defaultQueryData(this.queryData)
          }
        })
      },
      checkbox(row){
        this.deleteIds = row.map(key => key.id).join(",");
      },
      /*表格按钮点击事件*/
      bthClick (clickName, row) {
        this.initCascader();
        if (clickName == "update"){
          this.$refs.childUpdate.open(row);
        }else if (clickName == "delete") {
            this.dataChanage(URL.type.del+"/"+row.id, {id: row.id}, res => {
                if (res.code == 0) {
                    this.$refs.childTable.defaultGetData(this.queryData);
                    this.$message.success("suc");
                    this.initCascader();
                } else {
                    this.$message.error(res.message);
                }
            });
        }
      },
      /*查询表单按钮点击事件*/
      formclick(clickName, data){
        if("查询" == clickName){
          this.queryData = data;
          this.$refs.childTable.defaultQueryData(data);
        }else if("新增" == clickName){
          this.$refs.childUpdate.open();
        }
      },
      /*新增或跟提交数据触发事件*/
      submit(model){
        let models = JSON.parse(JSON.stringify(model))
        models.pids = model.pids ? model.pids.join(',') : ""
        //根据是否包含id更新还是添加
        this.dataChanage((model.id!=undefined && model.id!=null && model.id!='') ? URL.type.edit:URL.type.edit,models,res => {
        if (res.code == 0){
          this.$refs.childUpdate.close();
          this.$message.success("操作成功");
          this.$refs.childTable.defaultGetData(this.queryData);
          this.initCascader();
        }else{

        }
      })
      },
      dataChanage(url,option,suc,fail){
        this.$axios.post(url, Qs.stringify(option || {})).then(res => {
        if(suc && (typeof suc == 'function')) suc(res);
      }).catch(res => {
          if(fail && (typeof fail == 'function')) fail(res);
      })
      }
    },
    data () {
      return {
        deleteIds:"",
        queryData:{},
        /*新增或更新*/
        updateData:{
          cols:[
                  { title: 'id', field: 'id',hidden: true},
                  { title: '资讯类型', field: 'pids', type: 15, optionList: newsTypeList, data: [] ,checkStrictly:true},
                  { title: 'name', field: 'name'},
              ]
        },
        /*from查询表单*/
        formData:{
          hasLable: true,
          cols:[
              { title: 'name', field: 'name'},
              {click:"查询",auth:"cms:type:list"},
              {click:"新增",auth:"cms:type:save"}
          ]
        },
        /*table生成*/
        pageData: {
          queryUrl: URL.type.query, //请求路径和参数
          selection: true,
          sequence: true,
          cols: [
                      { title: '主键', field: 'id'},
                      { title: 'name', field: 'name'},
                      { title: 'pid', field: 'pid'},
                       { title: 'pids', field: 'pids'},
                       { title: 'pnames', field: 'pnames'},
                       { title: 'companyCode', field: 'companyCode'},
             {title:"操作",btnClick:[{name:"删除",click:"delete",type:"primary",icon:"el-icon-delete",auth:"cms:type:del"},{name:"修改",click:"update",type:"primary",icon: "el-icon-edit",auth:"cms:type:edit"}]},

          ]
        }
      }
    }
  }
</script>
